module.exports = __webpack_public_path__ + "static/media/ii18.37dca12d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/igor by igor/ii18.jpg
// module id = 519
// module chunks = 0